import { CheckoutSection } from './CheckoutSection';
import { SpecialDeliveryFormData } from '../../types';

interface SpecialDeliveryProps {
  value: SpecialDeliveryFormData;
  onChange: (data: SpecialDeliveryFormData) => void;
  minDayToEvent?: number | null;
  errors?: Partial<Record<keyof SpecialDeliveryFormData, string>>;
}

export function SpecialDeliverySection({ value, onChange, errors = {} }: SpecialDeliveryProps) {
  const set = (field: keyof SpecialDeliveryFormData) => (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const updated = { ...value, [field]: e.target.value };

    // Auto-fill end date when start is set and end is still empty
    if (field === 'deliveryStartDate' && !value.deliveryEndDate) {
      updated.deliveryEndDate = e.target.value;
    }
    if (field === 'eventStartDate' && !value.eventEndDate) {
      updated.eventEndDate = e.target.value;
    }

    onChange(updated);
  };

  return (
    <CheckoutSection title="Special Delivery Instructions">
      <div className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Delivery Start Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              value={value.deliveryStartDate}
              onChange={set('deliveryStartDate')}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
            {errors.deliveryStartDate && (
              <p className="mt-1 text-sm text-red-600">{errors.deliveryStartDate}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Delivery End Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              value={value.deliveryEndDate}
              onChange={set('deliveryEndDate')}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
            {errors.deliveryEndDate && (
              <p className="mt-1 text-sm text-red-600">{errors.deliveryEndDate}</p>
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Event Start Date
            </label>
            <input
              type="date"
              value={value.eventStartDate}
              onChange={set('eventStartDate')}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
            {errors.eventStartDate && (
              <p className="mt-1 text-sm text-red-600">{errors.eventStartDate}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Event End Date
            </label>
            <input
              type="date"
              value={value.eventEndDate}
              onChange={set('eventEndDate')}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
            {errors.eventEndDate && (
              <p className="mt-1 text-sm text-red-600">{errors.eventEndDate}</p>
            )}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Shipment Content
          </label>
          <textarea
            value={value.shipmentContent}
            onChange={set('shipmentContent')}
            rows={3}
            maxLength={1000}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
            placeholder="Describe the contents of your shipment..."
          />
          {errors.shipmentContent && (
            <p className="mt-1 text-sm text-red-600">{errors.shipmentContent}</p>
          )}
        </div>
      </div>
    </CheckoutSection>
  );
}
